import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography
} from '@mui/material';

import { isEmpty } from 'underscore';


const UserForm = ({editMode, model, onAction, onBack, formDisabled }) => {

    console.log("User Form Render");
    const [formValues, setFormValues] = useState(model);
    const [touched, setTouched] = useState(false);
    const [formErrors, setFormErrors] = useState({
      name: "",
      surname: "",
      mobile: "",
    });

    // update form fields if model changes
    React.useEffect(() => {
      setFormValues(model);

    }, [model])
    
    const handleChange = (event) => {
        
        setFormValues({
          ...formValues,
          [event.target.name]: event.target.value
        });
        setTouched(true);
    };

    const validateForm = (values) => {

      const emptyMsg = "Can't be empty"
      let errors = {};
      if(!values.name) errors.name = emptyMsg;
      if(!values.email) errors.email = emptyMsg;


      return errors;
    }

    const onFormSubmit = (event) => {
        
        const validate = validateForm(formValues);

        if(isEmpty(validate)) onAction(formValues);
        else setFormErrors({ ...validate });

    }

    return (
        <>
        <form
        autoComplete="off"

        >
          <fieldset disabled={ formDisabled ? "disabled" : false} style={{border:0}}>
          <Grid
            container
            spacing={3}
          >
            { formDisabled &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <Typography variant="pred">Editing is disabled.</Typography>
              </Grid>
            }
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Name"
                name="name"
                onChange={handleChange}
                required
                value={formValues.name}
                variant="outlined"
                helperText={formErrors.name}
              />
            </Grid>
          
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Email"
                name="email"
                onChange={handleChange}
                required
                value={formValues.email}
                variant="outlined"
                helperText={formErrors.email}
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Password"
                name="password"
                onChange={handleChange}
                required
                value={formValues.password}
                variant="outlined"
                
              />
            </Grid>            
            <Grid
              item
              md={3}
              xs={12}
            >
              <TextField
                fullWidth
                label="DB ID"
                name="id"
                disabled
                value={formValues.id}
                variant="outlined"
                helperText="Database reference"
              />
            </Grid>                        
          </Grid>
       
      </fieldset>
      <Box
          sx={{
            display: 'flex',
            justifyContent:'flex-end',
            flexDirection: "row",
            columnGap:'10px',
            p: 2
          }}
        >
          { onBack && !touched &&
          <Button

            color="primary"
            variant="outlined"
            onClick={onBack}
          >
            Back
          </Button>
          }

          <Button

            color="primary"
            variant="outlined"
            onClick={onFormSubmit}
          >
            Update
          </Button>


        </Box>
      </form>
    </>
    );

}

export default UserForm;